import React, { useRef, useEffect, useState } from 'react';

const LazyLoadVideo = ({ src, poster, className, ...props }) => {
    const videoRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.25 }
        );

        if (videoRef.current) {
            observer.observe(videoRef.current);
        }

        return () => observer.disconnect();
    }, []);

    return (
        <div className={className} ref={videoRef}>
            {isVisible ? (
                <video
                    className='rounded'
                    controls
                    autoPlay
                    muted
                    loop
                    preload="none"
                    poster={poster}
                    {...props}
                >
                    <source src={src} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            ) : (
                <img src={poster} alt="video placeholder" style={{ width: '100%' }} />
            )}
        </div>
    );
};

export default LazyLoadVideo;
